module.exports = __webpack_public_path__ + "img/galaxyFormation.1533e758.jpg";